import { Styles } from 'shared/types';

export const Container: Styles = {
  display: 'flex',
};
